export const FETCH_POWER_BI_REPORT_REQUEST = 'FETCH_POWER_BI_REPORT_REQUEST';
export const FETCH_POWER_BI_REPORT_SUCCESS = 'FETCH_POWER_BI_REPORT_SUCCESS';
export const FETCH_POWER_BI_REPORT_FAILURE = 'FETCH_POWER_BI_REPORT_FAILURE';